import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSafeArea = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 29,
	viewBox: "0 0 28 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.23808 13.0733C9.6051 7.10343 11.2886 4.11853 13.9546 4.11853C16.6205 4.11853 18.3041 7.10343 21.6711 13.0733L22.0906 13.8172C24.8887 18.778 26.2877 21.2585 25.0232 23.0721C23.7588 24.8858 20.6306 24.8858 14.3742 24.8858H13.535C7.27858 24.8858 4.15035 24.8858 2.88595 23.0721C1.62155 21.2585 3.02054 18.778 5.81851 13.8172L6.23808 13.0733Z",
			stroke: "currentColor",
			strokeWidth: 1.73061
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9541 9.88721V15.6559",
			stroke: "currentColor",
			strokeWidth: 1.73061,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9543 20.2709C14.5915 20.2709 15.108 19.7543 15.108 19.1171C15.108 18.4799 14.5915 17.9634 13.9543 17.9634C13.3171 17.9634 12.8005 18.4799 12.8005 19.1171C12.8005 19.7543 13.3171 20.2709 13.9543 20.2709Z",
			fill: "currentColor"
		})
	]
});
export default SvgSafeArea;
